// extracted by mini-css-extract-plugin
export var cdBackgroundCard = "background-card-module--cd-background-card--d1bd7";
export var cdBackgroundCardContent = "background-card-module--cd-background-card-content--f10f2";
export var cdBackgroundCardWrapper = "background-card-module--cd-background-card-wrapper--39032";
export var cdBackgroundOverlay = "background-card-module--cd-background-overlay--26708";
export var cdButton = "background-card-module--cd-button--3b783";